<nb-card>
  <nb-card-header>لیست واریز رمزارز</nb-card-header>
  <nb-card-body>
    <div class="d-none d-lg-flex align-items-center mb-2">
      <nb-select
        class="ms-2"
        [selected]="15"
        (selectedChange)="changeRecordPerPageLimit($event)"
        placeholder="تعداد رکورد"
      >
        <nb-option [value]="10">10</nb-option>
        <nb-option [value]="15">15</nb-option>
        <nb-option [value]="25">25</nb-option>
        <nb-option [value]="50">50</nb-option>
        <nb-option [value]="100">100</nb-option>
      </nb-select>
    </div>
    <p-table
      [value]="pagination.data"
      [tableStyleClass]="'table text-center table-striped  stacked-table table-hover'"
      [lazy]="true"
      (onLazyLoad)="getDepositList($event)"
      [alwaysShowPaginator]="false"
      [autoLayout]="true"
      [paginator]="true"
      [rows]="limit"
      [totalRecords]="pagination.totalRecords"
      [loading]="loading"
    >
      <ng-template pTemplate="header">
        <tr>
          <th>اپراتور واریز</th>
          <th>شناسه کاربر</th>
          <th>شناسه</th>
          <th>ارز</th>
          <th>کاربر</th>
          <th>کیف پول</th>
          <th>مقدار</th>
          <th>شناسه تراکنش</th>
          <th>شبکه</th>
          <th>مبدا انتقال</th>
          <th>تعداد تایید در شبکه</th>
          <th>تاریخ ایجاد</th>
          <th>تاریخ انجام</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-deposit>
        <tr>
          <td>
            <a
              *ngIf="deposit.adminUser?.id;else empty"
              class="text-primary"
              [routerLink]="deposit.user?.id ? '/dashboard/user/' + deposit.adminUser?.id : null"
            >
              {{
                deposit.adminUser?.firstName || deposit.adminUser?.lastName
                  ? deposit.adminUser.firstName + ' ' + deposit.adminUser.lastName
                  : '-'
              }}
            </a>
          </td>
          <td>{{ deposit.user.id }}</td>
          <td>{{ deposit.id }}</td>
          <td>{{ deposit.currency?.name }}</td>
          <td>
            <a
              class="text-primary"
              [routerLink]="deposit.user?.id ? '/dashboard/user/' + deposit.user?.id : null"
            >
              {{
                deposit.user?.firstName || deposit.user?.lastName
                  ? deposit.user.firstName + ' ' + deposit.user.lastName
                  : '-'
              }}
            </a>
          </td>
          <td class="code">
            <ng-container *ngIf="deposit.wallet; else empty">
              <i
                (click)="copy(deposit.wallet, 'آدرس کیف پول کپی شد.')"
                class="far fa-copy ms-2 align-middle cursor-pointer text-primary"
              ></i>
              <div class="d-inline-block" [nbTooltip]="deposit.wallet" [nbTooltipClass]="'code'">
                <span>{{ deposit.wallet.substring(0, 6)?.trim() }}</span>
                <i class="far fa-ellipsis-h mx-1 align-middle" style="opacity: 80%"></i>
                <span>
                  {{
                    deposit.wallet
                      .substring(deposit.wallet.length - 6, deposit.wallet.length)
                      ?.trim()
                  }}
                </span>
              </div>
            </ng-container>
          </td>
          <td>
            {{ deposit.amount | number : '1.0-8' }}
          </td>
          <td class="code">
            <ng-container *ngIf="deposit.hash; else empty">
              <i
                (click)="copy(deposit.hash, 'شناسه تراکنش کپی شد.')"
                class="far fa-copy ms-2 align-middle cursor-pointer text-primary"
              ></i>
              <div class="d-inline-block" [nbTooltip]="deposit.hash" [nbTooltipClass]="'code'">
                <span>{{ deposit.hash.substring(0, 6)?.trim() }}</span>
                <i class="far fa-ellipsis-h mx-1 align-middle" style="opacity: 80%"></i>
                <span>
                  {{ deposit.hash.substring(deposit.hash.length - 6, deposit.hash.length)?.trim() }}
                </span>
              </div>
            </ng-container>
          </td>
          <td>{{ deposit.network ?? '-' }}</td>
          <td>
            <a
              *ngIf="deposit.transferType === TransferType.Internal"
              href="/dashboard/user/{{deposit.originUser.id}}"
              [nbPopover]="originTemp"
              nbPopoverPlacement="top"
              nbPopoverTrigger="hover"
              nbButton
              ghost
            >
              {{ deposit.originUser.firstName + ' ' +  deposit.originUser.lastName}}
            </a>
            <ng-template #originTemp>
              <div class="origin-tooltip">
                <p>ایمیل: {{deposit.originUser.email}}</p>
                <p>کیف پول: {{deposit.originWallet}}</p>
              </div>

            </ng-template>

            <ng-container *ngIf="deposit.transferType === TransferType.External">{{deposit.transferType | transferType}}</ng-container>
          </td>
          <td>
            {{ deposit.confirmations ?? '-' }}
          </td>
          <td>
            {{ deposit.createdAt | dateFormat : 'HH:mm jYYYY/jMM/jDD' }}
          </td>
          <td>
            {{
              deposit.receivedAt ? (deposit.receivedAt | dateFormat : 'HH:mm jYYYY/jMM/jDD') : '-'
            }}
          </td>
        </tr>
      </ng-template>
    </p-table>
  </nb-card-body>
</nb-card>
<ng-template #empty>-</ng-template>
